import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 8,
	viewBox: "0 0 11 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.4375 4L4.28726 7L9.99684 1",
		stroke: "#8E68F7",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCheckIcon;
